import {
  AssessmentMethodology,
  AssetType,
  InterventionType,
  MappedDropDownOptions,
} from "./types";
import { removeNonValues } from "./form/utils";
import { createAddSolutionPayload } from "./add/form/payload";
import { createEditSolutionPayload } from "./edit/form/payload";
import { OutcomeType } from "./form/types";
import sdg1 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-01.png";
import sdg2 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-02.png";
import sdg3 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-03.png";
import sdg4 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-04.png";
import sdg5 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-05.png";
import sdg6 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-06.png";
import sdg7 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-07.png";
import sdg8 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-08.png";
import sdg9 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-09.png";
import sdg10 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-10.png";
import sdg11 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-11.png";
import sdg12 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-12.png";
import sdg13 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-13.png";
import sdg14 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-14.png";
import sdg15 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-15.png";
import sdg16 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-16.png";
import sdg17 from "./details/tabs/earthly-org/references/sdgs/E-WEB-Goal-17.png";

export const SDGOptions = [
  {
    id: 1,
    displayValue: "No Poverty",
    color: "#e5233d",
    image: sdg1,
  },
  {
    id: 2,
    displayValue: "Zero Hunger",
    color: "#dea73a",
    image: sdg2,
  },
  {
    id: 3,
    displayValue: "Good Health & Wellbeing",
    color: "#4ca146",
    image: sdg3,
  },
  {
    id: 4,
    displayValue: "Quality Education",
    color: "#c7212f",
    image: sdg4,
  },
  {
    id: 5,
    displayValue: "Gender Equality",
    color: "#ef402d",
    image: sdg5,
  },
  {
    id: 6,
    displayValue: "Clean Water And Sanitation",
    color: "#27bfe6",
    image: sdg6,
  },
  {
    id: 7,
    displayValue: "Affordable And Clean Energy",
    color: "#fbc412",
    image: sdg7,
  },
  {
    id: 8,
    displayValue: "Decent Work And Economic Growth",
    color: "#a31c44",
    image: sdg8,
  },
  {
    id: 9,
    displayValue: "Industry, Innovation and Infrastructure",
    color: "#f26a2e",
    image: sdg9,
  },
  {
    id: 10,
    displayValue: "Reduced Inequalities",
    color: "#e01483",
    image: sdg10,
  },
  {
    id: 11,
    displayValue: "Sustainable Cities And Communities",
    color: "#f89d2a",
    image: sdg11,
  },
  {
    id: 12,
    displayValue: "Responsible Consumption And Production",
    color: "#a57f38",
    image: sdg12,
  },
  {
    id: 13,
    displayValue: "Climate Action",
    color: "#408046",
    image: sdg13,
  },
  {
    id: 14,
    displayValue: "Life Below Water",
    color: "#1f97d4",
    image: sdg14,
  },
  {
    id: 15,
    displayValue: "Life On Land",
    color: "#59ba47",
    image: sdg15,
  },
  {
    id: 16,
    displayValue: "Peace, Justice And Strong Institutions",
    color: "#136a9f",
    image: sdg16,
  },
  {
    id: 17,
    displayValue: "Partnerships For The Goals",
    color: "#14496b",
    image: sdg17,
  },
];

export const interventionTypeOptions: Array<InterventionType> = [
  "Afforestation, Reforestation, and Revegetation",
  "Improved Agricultural Land Management",
  "Improved Land Management",
  "Avoided Deforestation",
  "Restoring and Protecting Wetland Ecosystems",
  "Biochar",
  "Improved Forest Management",
  "Habitat Restoration and Creation",
  "Tree Planting",
];

export const assetTypeOptions: Array<AssetType> = [
  "Tree Planting",
  "Biodiversity Credits",
  "Innovation",
  "Carbon Credits: Removal",
  "Carbon Credits: Avoidance",
  "Carbon Credits: Avoidance & Removal",
];

export const assessmentMethodologyOptions: Array<AssessmentMethodology> = [
  "KEYSTONE_2.0",
  "KEYSTONE_3.0",
];

export const mappedMethodologyField: Array<
  MappedDropDownOptions<AssessmentMethodology>
> = [
  { value: "KEYSTONE_2.0", label: "Keystone 2.0" },
  { value: "KEYSTONE_3.0", label: "Keystone 3.0" },
];

export const getSDGDisplayValue = (id: number) => {
  return SDGOptions.find((sdg) => sdg.id === id)?.displayValue;
};

export const getSDGChipColor = (id: number) => {
  return SDGOptions.find((sdg) => sdg.id === id)?.color;
};

export const outcomesTouched = (formValues: {
  outcomes?: Array<OutcomeType>;
}) => {
  const outcomes = formValues.outcomes || [];

  const touchedContainers = outcomes.find(
    (outcome: OutcomeType) =>
      outcome.value ||
      outcome.unit ||
      outcome["unit-of-sale"] ||
      outcome["outcome-start-date"] ||
      outcome["outcome-end-date"],
  );

  return !!touchedContainers;
};

export const isUnitOfSaleSelected = (formValues: {
  outcomes?: Array<OutcomeType>;
}) => {
  const outcomes = formValues.outcomes || [];

  const outcomesWithUnitOfSaleSelected = outcomes.filter(
    (outcome: OutcomeType) => outcome["unit-of-sale"],
  );

  return outcomesWithUnitOfSaleSelected.length > 0;
};

export const isUnitOfSaleOutcomeFilledOut = (formValues: {
  outcomes?: Array<OutcomeType>;
}) => {
  const outcomes = formValues.outcomes || [];

  const unitOfSaleOutcomes = outcomes.filter(
    (outcome: OutcomeType) => outcome["unit-of-sale"],
  );

  return (
    unitOfSaleOutcomes.length > 0 &&
    unitOfSaleOutcomes.every(
      (outcome: OutcomeType) => !!(outcome.value && outcome.unit),
    )
  );
};

export default {
  SDG: {
    SDGOptions: Object.freeze(SDGOptions),
    getSDGDisplayValue,
    getSDGChipColor,
  },
  SolutionFormBuilder: {
    removeNonValues,
    addSolution: createAddSolutionPayload,
    updateSolution: createEditSolutionPayload,
  },
};
